import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import "styled-components/macro";
import {
  TimelineItem,
  TimelineSeparator,
  TimelineDot,
  TimelineConnector,
  TimelineContent,
  Timeline,
} from "@material-ui/lab";
import { theme } from "config/theme";
import { Typography, Divider } from "@material-ui/core";
import useText from "constants/text";

export interface PersonalOrderDetailProps {
  sender: any;
  receiver: any;
  height?: number | string;
  width?: number | string;
}

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      margin: theme.spacing(1),
      justifyContent: "start",
      justifyItems: "start",
      marginTop: "auto",
      marginBottom: "auto",
    },
    diviser: {
      marginTop: 20,
      marginBottom: 20,
    },
    senderTitle: {
      color: theme.palette.primary.main,
      fontWeight: "bold",
      fontSize: 12,
    },
    reciverTitle: {
      color: "#fbc666",
      fontWeight: "bold",
      fontSize: 12,
    },
    title: {
      [theme.breakpoints.down("xs")]: {
        fontSize: 10,
        width: "100%"
      }
    },
    addressName: {
      color: "#1F1D1C",
      fontWeight: "bold"
    },
    text: {
      fontStyle: "italic",
      color: "#707070",
      fontSize: 14,
      [theme.breakpoints.down("xs")]: {
        fontSize: 10,
        width: "100%"
      }
    },
    receiverStyle: {
      [theme.breakpoints.down("xs")]: {
        fontSize: "10px",
      }
    }
  })
);

export function PersonalOrderDetail({
  sender,
  receiver,
  height = 260,
  width = 382,
}: PersonalOrderDetailProps) {
  const styles = useStyles();
  const { text } = useText();
  return (
    <div
      className={styles.root}
      style={{
        height,
        width,
      }}
      css={`
        opacity: 0.6;
        border-radius: 17px;
        background-color: #e3f8fa;
        display: flex;
      `}
    >
      <Timeline
        className={styles.root}
        css={`
          margin-left: -10px;
        `}
      >
        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot
              css={`
                background-color: #26c6da;
              `}
            />
            <TimelineConnector
              css={`
                background-color: transparent;
                border-left: 3px dotted #dadbdb;
                margin-left: 3px;
              `}
            />
          </TimelineSeparator>
          <TimelineContent
            css={`
              padding-right: 0;
              padding-left: ${theme.spacing(1)}px;
              flex-basis: 100%;
            `}
          >
            <Typography className={styles.senderTitle}>{text.all.sender}</Typography>
            <Typography className={styles.title}>
              {sender?.name ?? `${text.all.name}...`},{" "}
              {sender?.entrepriseClientName ?? `${text.all.entreprise}...`}
            </Typography>
            <Typography className={styles.addressName}>
              {sender?.entrepriseAddressName ?? `${text.all.entreprise}...`}
            </Typography>
            <Typography className={styles.text}>
              {sender?.address ?? `${text.all.address}...`}
            </Typography>
            <Divider className={styles.diviser} />
          </TimelineContent>
        </TimelineItem>

        <TimelineItem>
          <TimelineSeparator>
            <TimelineDot
              css={`
                background-color: #fbc666;
              `}
            />
          </TimelineSeparator>
          <TimelineContent
            css={`
              padding-right: 0;
              padding-left: ${theme.spacing(1)}px;
              flex-basis: 100%;
            `}
          >
            <Typography className={styles.reciverTitle}>{text.all.receiver}: </Typography>
            {receiver ? (
              <>
                <Typography className={styles.receiverStyle}>
                  {receiver?.name ? `${receiver?.name} , ` : ''}
                  {receiver?.number ?? ''}
                </Typography>
                <Typography className={styles.text}>
                  {receiver?.address ?? ''}
                  <br />
                  {receiver?.adress_details ?? ''}
                </Typography>
              </>
            ) : (
              ""
            )}
          </TimelineContent>
        </TimelineItem>
      </Timeline>
    </div>
  );
}
